export class ApplicationAssetApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getAssets({ applicationId }) {
    return this.#http.get(`/application/${applicationId}/asset`);
  }

  async createAsset({ applicationId, withLoanOptionId, ...body }) {
    return this.#http.post(`/application/${applicationId}/asset`, body, {
      params: { withLoanOptionId },
    });
  }

  async editAsset({ applicationId, assetId, withLoanOptionId, ...body }) {
    return this.#http.put(`/application/${applicationId}/asset/${assetId}`, body, {
      params: { withLoanOptionId },
    });
  }

  async deleteAsset({ applicationId, assetId, withLoanOptionId, tabId }) {
    return this.#http.delete(`/application/${applicationId}/asset/${assetId}`, {
      params: { withLoanOptionId, tabId },
    });
  }

  async editAssetOwners({ applicationId, assetId, withLoanOptionId, ...body }) {
    return this.#http.put(`/application/${applicationId}/asset/${assetId}/owners`, body, {
      params: { withLoanOptionId },
    });
  }

  async refreshAssetFinicity({ applicationId, withLoanOptionId, saveWithoutProgram }) {
    return this.#http.post(`/application/${applicationId}/asset/finicity/refresh`, null, {
      params: { withLoanOptionId, saveWithoutProgram },
    });
  }
}
